<template>
  <CockpitDialog
    class="collision-detail-dialog left-520px top-200px"
    title="编辑碰撞检查"
    @close="close"
  >
    <el-form
      :model="formData"
      :rules="formRules"
      ref="collisionForm"
      class="collision-form-wrap mt-15px"
      label-width="120px"
      v-loading="formLoading"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="碰撞编号" prop="no">
            <el-input v-model="formData.no" size="small" placeholder="请填写碰撞编号"></el-input>
          </el-form-item>
          <el-form-item label="主体编码" prop="mainCode">
            <el-input
              v-model="formData.mainCode"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="客体编码" prop="guestCode">
            <el-input
              v-model="formData.guestCode"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="碰撞坐标">
            <div class="position-wrap flex">
              <el-input
                size="small"
                v-model="formData.xPosition"
                placeholder="自动回显"
                readonly
              ></el-input>
              <el-input
                size="small"
                v-model="formData.yPosition"
                placeholder="自动回显"
                class="ml-5px"
                readonly
              ></el-input>
              <el-input
                size="small"
                v-model="formData.zPosition"
                placeholder="自动回显"
                class="ml-5px"
                readonly
              ></el-input>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="创建日期" prop="checkTime">
            <el-input
              v-model="formData.checkTime"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="主体名称" prop="mainName">
            <el-input
              v-model="formData.mainName"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
          <el-form-item label="客体名称" prop="guestName">
            <el-input
              v-model="formData.guestName"
              size="small"
              placeholder="自动回显"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="碰撞描述" prop="description" class="desc-input">
            <el-input
              v-model="formData.description"
              size="small"
              type="textarea"
              :rows="3"
              placeholder="请填写描述"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-col :span="24" class="flex justify-center">
      <el-button @click="saveHandler" size="small" type="primary" data-marked="true"
        >保存</el-button
      >
      <el-button @click="close" size="small" type="primary" class="ml-20px">取消</el-button>
    </el-col>
  </CockpitDialog>
</template>

<script>
import { cloneDeep } from 'lodash'
import { CollisionCheckApi } from '@wiz-api/haiguang'
import EventBus from './js/eventBus'

const collisionCheckApi = new CollisionCheckApi()

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}

export default {
  components: { CockpitDialog },
  props: {
    collisionDetail: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      formLoading: false,
      formData: {
        id: null,
        no: '',
        checkTime: '',
        mainCode: '',
        mainName: '',
        guestCode: '',
        guestName: '',
        xPosition: '',
        yPosition: '',
        zPosition: '',
        description: '',
      },
      formRules: {
        no: { required: true, message: '请填写碰撞编号', trigger: 'change' },
      },
    }
  },
  watch: {
    'collisionDetail.id': {
      handler(newVal, oldVal) {
        this.formData = this.$options.data().formData
        if (newVal) {
          this.formData = Object.assign(this.formData, this.collisionDetail)
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  created() {
    this.formData = Object.assign(this.formData, this.collisionDetail)
  },
  methods: {
    // 关闭阀门详情弹窗
    close() {
      this.$emit('closeCollisionEdit')
    },
    saveHandler() {
      this.$refs.collisionForm.validate(async (valid) => {
        if (valid) {
          const [err, res] = await collisionCheckApi.saveCollisionCheck({
            body: {
              ...this.formData,
              tenantId:
                localStorage.getItem('CurrentTenantId') ||
                localStorage.getItem('TenantId') ||
                JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId,
            },
          })
          if (!err) {
            this.$message.success('保存成功')
            this.close()
            EventBus.$emit('CollisionEditSuccess')
          }
        }
      })
    },
  },
  beforeDestroy() {},
}
</script>
<style lang="scss" scoped>
.collision-detail-dialog {
  .button-bg-img {
    background: url('../../../assets/images/button_blue.png');
    background-size: 100% 100%;
  }
  ::v-deep .el-loading-mask {
    background: #1a4447ad !important;
  }
  ::v-deep .el-input .el-input__inner {
    height: 28px !important;
    line-height: 28px !important;
    width: 250px !important;
  }
  ::v-deep .el-button {
    background-color: rgb(67 153 174 / 35%) !important;
    background-image: none !important;
    border: 1px solid #629eaa !important;
    border-radius: 2px !important;
    height: 36px !important;
    &[data-marked='true'] {
      background: linear-gradient(0deg, #4399ae59, #4399ae) !important;
    }
  }
  .position-wrap {
    ::v-deep .el-input {
      width: 80px !important;
      .el-input__inner {
        width: 100% !important;
        padding: 0 5px !important;
      }
    }
  }
  .collision-form-wrap {
    ::v-deep .el-input__inner {
      border: 1px solid #ffffff54 !important;
    }
    ::v-deep .el-textarea__inner {
      border: 1px solid #ffffff54 !important;
    }
  }
}
</style>
